
import React, { Component } from 'react';
import {
  Box,
  Checkbox,
  TableCell,
  TableRow,
} from '@material-ui/core';
import PropTypes from 'prop-types';

class EcommDataCheckBoxRow extends Component {
  render() {
    const {
      rowTitle,
      tableDataSet,
      disabled,
      checkboxKey,
      rowClassName,
      onChange
    } = this.props;

    return (
      <TableRow>
        <TableCell key={checkboxKey} className="ecommTableLabel">
          <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
            {rowTitle}
          </Box>
        </TableCell>
        {Object.keys(tableDataSet).map((element) => {
          return (
            <TableCell
              key={element}
              className={rowClassName}
            >
              <Checkbox
                className="studioDataCheckbox"
                checked={tableDataSet[element][checkboxKey]}
                name={checkboxKey}
                disabled={disabled}
                onChange={event =>
                  onChange(event, element)
                }
              />
            </TableCell>
          )
        })}
      </TableRow>
    )
  }
}

EcommDataCheckBoxRow.propTypes = {
  rowTitle: PropTypes.string.isRequired,
  tableDataSet: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  disabled: PropTypes.bool.isRequired,
  checkboxKey: PropTypes.string.isRequired,
  rowClassName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default EcommDataCheckBoxRow;
